import { useTranslation } from "react-i18next";
import SEO from "./common/SEO";

const Curriculum = ({ renderBody }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "Curriculum & Artistic Career" : "Curriculum & Attività Artistica";
  const desc = isEnglish
    ? "Curriculum and prestigious artistic history of the Nuova Orchestra da Camera Ferruccio Busoni: tours, prizes, festival appearances, and recordings."
    : "Curriculum e prestigiosa attività artistica della Nuova Orchestra da Camera Ferruccio Busoni: tournée internazionali, collaborazioni, dischi e riconoscimenti.";

  const rawBody = t("cv.body");

  // Format body text cleanly into distinct narrative paragraphs
  const getFormattedBody = () => {
    if (!rawBody) return null;
    if (rawBody.includes("\n")) {
      return renderBody(rawBody);
    }
    // If Italian text has no newlines, split at natural thematic sections
    const splitPhrases = [
      "E’ formata da affermati strumentisti",
      "L’orchestra si è posta all’attenzione del pubblico",
      "Ha presentato molte opere in prima esecuzione assoluta",
      "L’orchestra Busoni è l’ideatrice",
      "La rivista AMADEUS",
      "Il 60° anniversario dell’orchestra",
    ];
    let formattedText = rawBody;
    splitPhrases.forEach((phrase) => {
      formattedText = formattedText.replace(phrase, `\n\n${phrase}`);
    });
    return renderBody(formattedText);
  };

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section subpage-section">
        <div className="container subpage-reading-container">
          <div className="curriculum-editorial-body text-start">
            {getFormattedBody()}
          </div>
        </div>
      </section>
    </>
  );
};

export default Curriculum;
